import Link from "next/link";
import { Col, Row } from "react-bootstrap";
import Paragraph from "src/components/Paragraph";
import Text from "src/components/Text";
import { sLink } from "src/styles/sLink.module.scss";
import { DataClientForm } from "src/types/DataClientForm";

type Props = { userData: DataClientForm };

const CartAddress = ({ userData }: Props) => {
  return (
    <Row>
      <Col>
        <Paragraph className="text-center d-flex flex-column">
          <Text align="center" size="md" width={`semibold`}>
            {userData?.name}&nbsp;{userData?.surname}
          </Text>
          <Link href={`mailto:` + userData?.email} passHref>
            <a className={sLink}>{userData?.email}</a>
          </Link>
          <Text align="center">{userData?.phone}</Text>
          <Text align="center">{userData?.address?.street}</Text>
          <Text align="center">{userData?.address?.city}</Text>
          <Text align="center">{userData?.address?.zip}</Text>
          <Text align="center">{userData?.address?.country}</Text>
        </Paragraph>
      </Col>
    </Row>
  );
};

export default CartAddress;
